import React from 'react'
import BannerText from './BannerText'
import SocialsIcon from './Socials-Icon/SocialsIcon'
function Banner() {
  return (
    <div className='banner' id='anasayfa'>
        <SocialsIcon/>
        <BannerText/>
    </div>
  )
}

export default Banner
